let currentSpaces: any[] = [];
let lastPicked = 0;

const isSameArray = (features: any[]) => {

    for (let i = 0; i < features.length; i++) {
        const f = features[i];
        if (features.length !== currentSpaces.length) {
            return false;
        }
        if (!currentSpaces.find((cs: any) => cs.properties.name === f.properties.name)) {
            return false;
        }
    }

    return true;
}

const getNext = (lastPicked: number, maxLength: number) => {
    if (lastPicked >= maxLength - 1) {
        return 0
    } else {
        return ++lastPicked;
    }
}

const circlePickSpaces = (features: any[]) => {
    if (!isSameArray(features)) {
        currentSpaces = features;
        lastPicked = 0;
        return 0;
    } else {
        const next = getNext(lastPicked, currentSpaces.length);
        lastPicked = next;
        return next;
    }

}

export { circlePickSpaces }